import Modal from "../Modal/Modal";
import { useState } from "react";
import "./addTask.css";
import { db } from "../../../firebase";
import { collection, addDoc, Timestamp } from "firebase/firestore";

function AddTask({ onClose, open }) {
  const [marka, setMarka] = useState("");
  const [product, setProduct] = useState("");

  /* function to add new task to firestore */
  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await addDoc(collection(db, "ilanlar"), {
        marka,
        product,
        completed: false,
        created: Timestamp.now(),
      });
      onClose();
    } catch (err) {
      alert(err);
    }
  };

  return (
    <Modal modalLable="Add Task" onClose={onClose} open={open}>
      <form onSubmit={handleSubmit} className="addTask" name="addTask">
        <label>Name</label>
        <input
          type="text"
          name="marka"
          onChange={(e) => setMarka(e.target.value.toUpperCase())}
          value={marka}
          placeholder="Enter marka"
        />
        <label>Surname</label>
        <input
          type="text"
          name="product"
          onChange={(e) => setProduct(e.target.value)}
          placeholder="Enter product"
        />
        <label>Age</label>
        <input type="text" name="age" placeholder="Enter Age" />
        <label>Username</label>
        <input type="text" name="username" placeholder="Enter username" />
        <label>Email</label>
        <input type="text" name="email" placeholder="Enter Email" />
        <label>Followers</label>
        <input type="text" name="followers" placeholder="Enter Followers" />
        <label>City</label>
        <input type="text" name="city" placeholder="Enter name" />

        <button type="submit">Done</button>
      </form>
    </Modal>
  );
}

export default AddTask;
